import React, { Component } from 'react';
import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

export default class VerificationPanel extends Component {
  render() {
    const submitTransferenceData = this.props.submitTransferenceData;
    const digitalWalletAccNumber = (this.props.user.digitalWalletAccNumber !== 'undefined' &&
      // eslint-disable-next-line no-undef, eqeqeq
      this.props.user.digitalWalletAccNumber != '' && !_.isEmpty(this.props.user.digitalWalletAccNumber)) ?
      this.props.user.digitalWalletAccNumber : submitTransferenceData.walletNumber;

    /* eslint-disable */
    const verificationForWallet = (
      <React.Fragment>
        {channel === constChannels.WAP ?
          <div className="col-xs-12 wrapInfo">
            <div className="innerHeaderInfo">
              {
                this.props.isEmployee && this.props.isEmployee !== 'true'
                ? 
                  <p style={{color: '#333333'}}>
                    Depósito a {submitTransferenceData.walletType}
                  </p>
                : 
                  <p style={{color: '#333333'}}>
                    Depósito a {submitTransferenceData.walletType.slice(0, 17)}
                  </p>
              }
            </div>
            <div className="innerInfo">
              <p style={{fontSize: '14px', color: '#333333'}}>Nombre</p>
              <p style={{fontSize: '14px', fontWeight: '700', color: '#333333'}} className="focusOption">
                {submitTransferenceData.walletHolderName 
                ? submitTransferenceData.walletHolderName 
                : submitTransferenceData.userName}
              </p>
              {submitTransferenceData.walletNumber ? 
                <div><p style={{fontSize: '14px', color: '#333333'}}>Número de {submitTransferenceData.walletType}</p>
                <p className="focusOption" style={{fontWeight: '700', fontSize: '14px', color: '#333333'}}>
                {(submitTransferenceData.walletType !== 'undefined' && submitTransferenceData.walletType == 'Monedero Digital' ) ? digitalWalletAccNumber : submitTransferenceData.walletNumber}
                  </p> </div> : null}
              {submitTransferenceData.accountNumber ? 
                <div style={{ paddingTop: '5%' }}><p style={{fontSize: '14px', color: '#333333'}}>Número de {submitTransferenceData.walletType}</p>
                <p className="focusOption" style={{fontWeight: '700', fontSize: '14px', color: '#333333'}} >{submitTransferenceData.accountNumber.replaceAll('X', '*')}</p> </div>
                : null}
              <hr />
              <div className="wrapTableData">
                <table className="tableData">
                  <tbody><tr>
                    <td>
                      <p><span style={{ fontSize: '14px', color: '#333333'}}>Monto de depósito</span></p>
                    </td>
                    <td>
                      <p><span style={{fontWeight: '700', fontSize: '14px', color: '#333333'}}>{commonUtil.getCurrency(submitTransferenceData.walletOrEmployeeCardAmount)}</span></p>
                    </td>
                  </tr>
                  </tbody></table>
              </div>
              {submitTransferenceData && +submitTransferenceData.walletCommissionAmount !== 0 ?
                <div className="wrapTableData">
                  <table className="tableData">
                    <tbody>
                      <tr>
                        <td>
                          <p style={{fontWeight: '700', fontSize: '14px', color: '#333333'}}><span className="minDetail">-{+submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.walletType}</span></p>
                        </td>
                        <td>
                          <p><span style={{fontWeight: '700', fontSize: '14px', color: '#333333'}}>-{commonUtil.getCurrency(submitTransferenceData.walletCommissionAmount)}</span></p>
                        </td>
                      </tr>
                    </tbody></table>
                </div>
                : null}
              <hr />
              <div className="wrapTableData">
                <table className="tableData">
                  <tbody><tr>
                    <td>
                      <p>
                        {this.props.loadFrom === 'verificationForm' 
                        ? <span style={{fontSize: '14px', color: '#333333'}}> Total a recibir </span> 
                        : <span style={{fontSize: '14px', color: '#333333'}}> Total a recibir </span>}
                      </p>
                    </td>
                    <td>
                      <p><span style={{fontSize: '14px', color: '#333333', fontWeight: '700'}}>{commonUtil.getCurrency(submitTransferenceData.totalAmount)}</span></p>
                    </td>
                  </tr>
                  </tbody></table>
              </div>
            </div>
          </div>
          : <div className="block-verification" style={{width: '85%', margin: 'auto'}}>
            <div className="header-verification vertical-center-left">
                {this.props.isEmployee && this.props.isEmployee !== 'true'
                ? <span>Depósito a {submitTransferenceData.walletType}</span>
              :  <span>Depósito a {submitTransferenceData.walletType.slice(0, 17)}</span>}
            </div>
            <div className="content row">
              <div className="col-xs-6 generalData">
                <div className="name">
                  <small style={{fontSize: '14px'}}>Nombre</small>
                  <p style={{fontWeight: '700', fontSize: '14px'}}>
                    {submitTransferenceData.walletHolderName ? submitTransferenceData.walletHolderName : submitTransferenceData.userName}
                  </p>
                </div>
                {submitTransferenceData.walletNumber ? 
                  <div>
                    {
                      this.props.isEmployee && this.props.isEmployee !== "true"
                      ?
                      <small style={{fontSize: '14px'}}>{submitTransferenceData.walletType}</small>
                      : 
                      <small style={{fontSize: '14px'}}>{submitTransferenceData.walletType.slice(0, 17)}</small>
                    }
                    <p style={{fontWeight: '700', fontSize: '14px'}}>{(submitTransferenceData.walletType !== 'undefined' && submitTransferenceData.walletType== 'Monedero Digital' ) ? digitalWalletAccNumber :submitTransferenceData.walletNumber}</p> 
                  </div> 
                : null}
                {submitTransferenceData.accountNumber ? 
                  <div>
                    <small style={{fontSize: '14px'}}>Número de {submitTransferenceData.walletType}</small>
                    <p style={{fontWeight: '700', fontSize: '14px'}}>{submitTransferenceData.accountNumber.replaceAll('X', '*')}</p> 
                  </div>
                : null}
              </div>
              <div className="col-xs-6">
                <div className="row blockDeposit">
                  <div className="col-xs-8">
                    <p style={{fontSize: '14px'}}>Monto del depósito</p>
                  </div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.walletOrEmployeeCardAmount)}</strong></div>
                </div>
                {submitTransferenceData && +submitTransferenceData.walletCommissionAmount !== 0 ?
                  <div className="row blockDeposit">
                    <div className="col-xs-8">
                      <p>-{+submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.walletType}</p>
                    </div>
                    <div className="col-xs-4 text-right"><strong>-{commonUtil.getCurrency(submitTransferenceData.walletCommissionAmount)}</strong></div>
                  </div> : null}
                <div className="row blockDeposit">
                  <div className="col-xs-8" style={{fontSize: '14px'}}>
                    {this.props.loadFrom === 'verificationForm' 
                    ? <p style={{fontSize: '14px'}}> Total a recibir </p> 
                    : <p> Total a recibir </p>}
                  </div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.totalAmount)}</strong></div>
                </div>
              </div>
            </div>
          </div>}
      </React.Fragment>
    );

    const verificationForCard = (
      <div>
        {channel === constChannels.WAP ?
          <div>
            <p><span style={{color: '#333333'}}>Fecha de operación &nbsp;</span>{commonUtil.formatDate(submitTransferenceData.transferDate, 'monthName')}</p>
            <div className="row">
              <div className="col-xs-12 wrapInfo">
                <div className="innerHeaderInfo">
                  <p>Depósito a la cuenta</p>
                </div>
                <div className="innerInfo">
                  <p>Nombre</p>
                  <p className="focusOption">{submitTransferenceData.accountName ? submitTransferenceData.accountName : submitTransferenceData.userName}</p>

                  <div className="card"><small>Tipo de cuenta / tarjeta</small>
                    <p>{submitTransferenceData.paymentType}</p>
                  </div>

                  {submitTransferenceData.number ? <div className="numberAccount">
                    <p>Número de cuenta<p>{submitTransferenceData.number}</p></p></div>
                    : <div className="numberAccount">
                      <p>Número de cuenta<p>{submitTransferenceData.cardNumber}</p></p></div>}
                  <hr />
                  <div className="wrapTableData">
                    <table className="tableData">
                      <tbody><tr>
                        <td>
                          <p><span>Monto de depósito</span></p>
                        </td>
                        <td>
                          <p><span>{commonUtil.getCurrency(submitTransferenceData.cardOrBankAmount)}</span></p>
                        </td>
                      </tr>
                      </tbody></table>
                  </div>

                  {submitTransferenceData && +submitTransferenceData.commissionAmount !== 0 ?
                    <tr>
                      <td>
                        <p><span className="minDetail">-{submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.paymentType}</span></p>
                      </td>
                      <td>
                        <p><span>-{commonUtil.getCurrency(submitTransferenceData.commissionAmount)}</span></p>
                      </td>
                    </tr>
                    : null}
                  <hr />
                  <div className="wrapTableData">
                    <table className="tableData">
                      <tbody><tr>
                        <td>
                          <p>{this.props.loadFrom === 'verificationForm' 
                            ? <span style={{fontSize: '14px'}}> Total a recibir </span> 
                            : <span> Total a recibido </span>}
                          </p>
                        </td>
                        <td>
                          <p><span>{commonUtil.getCurrency(submitTransferenceData.totalAmount)}</span></p>
                        </td>
                      </tr>
                      </tbody></table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <div className="block-verification" style={{width: '85%', margin: 'auto'}}>
            {/* <div className={this.props.loadFrom === 'verificationForm' ? 'date-verification text-right' : this.props.loadFrom === 'partialConfirmation' ? 'date-verification' : ''} ><span style={{color: '#333333'}}>Fecha de operación &nbsp;</span><strong>{commonUtil.formatDate(submitTransferenceData.transferDate, 'monthName')}</strong></div> */}
            <div className="header-verification vertical-center-left"><span>Depósito a la cuenta</span></div>
            <div className="content row">
              <div className="col-xs-6 generalData">
                <div className="name">
                  <small style={{fontSize: '14px'}}>Nombre</small>
                  <p style={{fontWeight: '700', fontSize: '14px'}}>
                    {submitTransferenceData.accountName ? submitTransferenceData.accountName : submitTransferenceData.userName}
                  </p>
                </div>
                <div className="card"><small>Tipo de cuenta / tarjeta</small>
                  <p>{submitTransferenceData.paymentType}</p>
                </div>
                {submitTransferenceData.number ? <div className="numberAccount">
                  <small>Número de cuenta<p>{submitTransferenceData.number}</p></small></div>
                  : <div className="numberAccount">
                    <small>Número de cuenta<p>{submitTransferenceData.cardNumber}</p></small></div>}
              </div>
              <div className="col-xs-6">
                <div className="row blockDeposit">
                  <div className="col-xs-8">
                    <p>Monto del depósito</p>
                  </div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.cardOrBankAmount)}</strong></div>
                </div>
                {submitTransferenceData && +submitTransferenceData.commissionAmount !== 0 ?
                  <div className="row blockDeposit">
                    <div className="col-xs-8">
                      <p>-{submitTransferenceData.commissionValue}% comsión por depósito a {submitTransferenceData.paymentType}</p>
                    </div>
                    <div className="col-xs-4 text-right"><strong>-{commonUtil.getCurrency(submitTransferenceData.commissionAmount)}</strong></div>
                  </div> : null}

                <div className="row blockDeposit">
                  <div className="col-xs-8">
                    {this.props.loadFrom === 'verificationForm' 
                      ? <p style={{fontSize: '14px'}}> Total a recibir </p> 
                      : <strong> Total a recibido </strong>
                    }
                   </div>
                  <div className="col-xs-4 text-right"><strong>{commonUtil.getCurrency(submitTransferenceData.totalAmount)}</strong></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
    /* eslint-enable */
    return (
      <React.Fragment>
        {this.props.submitTransferenceData && this.props.submitTransferenceData.walletType !== undefined && this.props.submitTransferenceData.walletType !== 'undefined' ?
          verificationForWallet
          : null}
        {this.props.submitTransferenceData && this.props.submitTransferenceData.paymentType ?
          verificationForCard : null}
      </React.Fragment>
    );
  }
}

